import { scriptsUninstallAll } from "../uninstallScript/uninstallScript";

async function uninstallAllFromMaximo(checkVersions) {
  return await scriptsUninstallAll(checkVersions);
}

export default uninstallAllFromMaximo;
